module.exports = __webpack_public_path__ + "media/images/views/home/benefit/benefit-4-341529941c435943e8f956e9d84f730c.png";